import { collection, getDocs, doc, setDoc, deleteDoc, writeBatch } from "firebase/firestore";
import { db } from "../Firebase";

export const DEFAULT_DIRECTOR_AVATAR = '/founder.svg';
export const DEFAULT_LEADER_AVATAR = '/cto.svg';

export const defaultMembers = [
  {
    id: 'director-1',
    name: 'Ashok Ravsaheb Joshi',
    role: 'Founder & Managing Director',
    tagline: '25+ Years of Industrial Energy Leadership',
    image: DEFAULT_DIRECTOR_AVATAR,
    bio: 'Ashok Ravsaheb Joshi has spent over 25 years piloting industrial electrical infrastructures and generator operations. Under his governance, Green Gusto has grown from a regional service shop into a certified multi-vertical energy firm powering national telecom networks, heavy manufacturing mills, and government grids.',
    quote: 'Our vision is not just supplying generators, it is securing continuous national growth by powering critical sectors with high reliability and zero downtime.',
    type: 'director'
  }
];

export const getMembers = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "members"));
    const list = [];
    querySnapshot.forEach((doc) => {
      list.push({ ...doc.data(), id: doc.id });
    });

    if (list.length === 0) {
      // Prepopulate Firestore with batch write
      const batch = writeBatch(db);
      defaultMembers.forEach((member) => {
        const docRef = doc(collection(db, "members"), member.id);
        batch.set(docRef, member);
      });
      await batch.commit();
      return defaultMembers;
    }

    list.sort((a, b) => {
      if (a.type === 'director' && b.type !== 'director') return -1;
      if (a.type !== 'director' && b.type === 'director') return 1;
      const orderA = a.order !== undefined ? a.order : 999;
      const orderB = b.order !== undefined ? b.order : 999;
      if (orderA !== orderB) return orderA - orderB;
      return a.id.localeCompare(b.id);
    });
    return list;
  } catch (error) {
    console.error("Error fetching members from Firestore: ", error);
    throw error;
  }
};

export const saveMember = async (member) => {
  try {
    if (!member || !member.id) {
      throw new Error("Member ID is required to save.");
    }
    const cleanMember = {};
    Object.keys(member).forEach((key) => {
      if (member[key] !== undefined) {
        cleanMember[key] = member[key];
      }
    });
    const docRef = doc(db, "members", member.id);
    await setDoc(docRef, cleanMember, { merge: true });
    return cleanMember;
  } catch (error) {
    console.error("Error saving member to Firestore: ", error);
    throw error;
  }
};

export const saveMembersOrder = async (membersList) => {
  try {
    const batch = writeBatch(db);
    membersList.forEach((member) => {
      const docRef = doc(db, "members", member.id);
      batch.set(docRef, member, { merge: true });
    });
    await batch.commit();
  } catch (error) {
    console.error("Error saving members order to Firestore: ", error);
    throw error;
  }
};

export const deleteMember = async (id) => {
  try {
    const docRef = doc(db, "members", id);
    await deleteDoc(docRef);
  } catch (error) {
    console.error("Error deleting member from Firestore: ", error);
    throw error;
  }
};
